module.exports = __webpack_public_path__ + "static/media/second-line.cae9e910.svg";